import { ChangeEvent, useState, useRef } from 'react';
import { Avatar, FileUploader } from 'components/ProfileUIComponents';
import { Text, Flexbox } from '@morressier/ts';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { uploadUserAvatar } from 'clients/internal/profileService';
import { getFileExtension } from 'utils/utils';
import {
  Label,
  LinkButton,
  PhotoContainer,
  PhotoInfoText,
  FieldContainer
} from './style';

const RemoveButton = styled(LinkButton)`
  margin-top: 8px;
  margin-bottom: 0;
`;

interface IProfilePhotoSection {
  userId: string;
  profilePhotoUrl?: string;
  setProfilePhoto: (photo: string) => void;
}

const ProfilePhotoSection = (props: IProfilePhotoSection) => {
  const [isPhotoUploading, setIsPhotoUploading] = useState<boolean>(false);
  const { userId, setProfilePhoto, profilePhotoUrl } = props;
  const fileUploaderRef = useRef<HTMLInputElement>(null);

  const onFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target?.files?.[0];
    if (file) {
      setIsPhotoUploading(true);
      const fileExtension = getFileExtension(file.name) || '';
      const url = await uploadUserAvatar(userId, fileExtension, file);
      setProfilePhoto(url || '');
      setIsPhotoUploading(false);
    }
  };

  const onRemovePhoto = () => {
    if (fileUploaderRef.current) {
      fileUploaderRef.current.value = '';
    }
    setProfilePhoto('');
  };
  return (
    <FieldContainer>
      <Label>
        <Text size="body1_new" fontWeight="bold">
          Profile Photo
        </Text>
      </Label>
      <Flexbox alignItems="flex-start">
        <Avatar src={profilePhotoUrl} isLoading={isPhotoUploading} />
        <PhotoContainer>
          <FileUploader
            accept=".png,.jpg,.jpeg"
            icon={<FontAwesomeIcon icon={faUpload} />}
            onChange={onFileChange}
            ref={fileUploaderRef}
          >
            Select Photo
          </FileUploader>
          <PhotoInfoText size="body1_new">
            You can use any photo (.jpeg, .jpg or .png) that is no larger than
            10 MB.
          </PhotoInfoText>
          {profilePhotoUrl && (
            <RemoveButton btnType="remove" onClick={onRemovePhoto}>
              <FontAwesomeIcon icon={faTrash} />
              Remove
            </RemoveButton>
          )}
        </PhotoContainer>
      </Flexbox>
    </FieldContainer>
  );
};
export default ProfilePhotoSection;
